import { LocalizedText, useSourceLanguage } from "../../i18n/LocalizedCopy";
import React, { forwardRef } from "react";

const WelcomeOfferSuccess = forwardRef(function WelcomeOfferSuccess(
  { onWallet, onRewards },
  titleRef
) {
  useSourceLanguage();
  return (
    <div className="welcome-offer-success">
      <div className="welcome-offer-success__mark" aria-hidden="true">
        <span>✓</span>
      </div>
      <p className="welcome-offer-details__eyebrow"><LocalizedText source={"CONFIRMATION ETERNUA"} /></p>
      <h2 id="welcome-offer-title" ref={titleRef} tabIndex="-1"><LocalizedText source={"Bonus activé"} /></h2>
      <p id="welcome-offer-description"><LocalizedText source={"Ton bonus a été ajouté à ton portefeuille Eternua."} /></p>
      <p className="welcome-offer-success__more"><LocalizedText source={"Profite de tes autres récompenses."} /></p>
      <div className="welcome-offer-success__actions">
        <button type="button" className="welcome-offer-actions__primary" onClick={onWallet}>
          <span><LocalizedText source={"Ouvrir mon portefeuille"} /></span><span aria-hidden="true">→</span>
        </button>
        <button type="button" className="welcome-offer-actions__secondary" onClick={onRewards}><LocalizedText source={"Découvrir mes récompenses"} /></button>
      </div>
    </div>
  );
});

export default WelcomeOfferSuccess;
